import { render, staticRenderFns } from "./UkrposhtaTable.vue?vue&type=template&id=2c9193bc&scoped=true"
import script from "./UkrposhtaTable.vue?vue&type=script&lang=js"
export * from "./UkrposhtaTable.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaTable.vue?vue&type=style&index=0&id=2c9193bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9193bc",
  null
  
)

export default component.exports